module.exports = __webpack_public_path__ + "img/oformite.e41633ad.png";